import React, { useState, useEffect } from 'react';

import { makeStyles } from "@material-ui/core/styles";
import TableContacts from "components/TableContact/TableContact.js";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import api from "assets/services/api";

import ModalAddContacts from "components/ModalAddContacts/ModalAddContacts";
import ModalDeleteContacts from "components/ModalDeleteContacts/ModalDeleteContacts";
import ModalUpdateContacts from "components/ModalUpdateContacts/ModalUpdateContacts";
import { useCallback } from 'react';


const styles = {
    btnFindClient: {
        backgroundColor: "#4169e1",
        marginTop: "25%",
        '&:hover': {
            backgroundColor: '#303f9f',
        },
    },
    sizeAddContact: {
        color: "#4169e1",
        overflow: "visible",
        marginTop: "20px"
    },
    buttonIcon: {
        fontSize: "50px",
        padding: "0"
    },
    imageTabulation: {
        width: 90,
        height: 90,
        borderRadius: 90,
        marginRight: 20 / 2
    }

};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
function ModalTableContacts(props) {

    const id_client = props.props.id

    const [contacts, setContacts] = useState([]);
    const classes = useStyles();
    const classes2 = useStyles2();
    const [index, setIndex] = useState({ id: 0 });
    const [modalDeleteContacts, setModalDeleteContact] = useState(false);
    const [modalUpdateContacts, setModalUpdateContacts] = useState(false);
    const [modalAddContact, setModalAddContact] = useState(false);
    const [buttonClient, setButtonClient] = useState(true);
    const [buttonDelete, setButtonDelete] = useState(true);


    useEffect(() => {

        loadContacts();
    }, [])

    const loadContacts = async () => {
        const contacts = await api.get('/client/contact/' + id_client)
        if (contacts.data[0]) {
            setContacts(contacts.data)
        } else { setContacts(id_client) }
    }




    useEffect(() => {
        if (contacts) {
            contacts.length === 3 ? setButtonClient(false) : setButtonClient(true)
            contacts.length <= 1 ? setButtonDelete(false) : setButtonDelete(true)
        }
    }, [contacts]);

    function callModalDeleteContact(index) {
        setIndex(index)
        setModalDeleteContact(true)
    }

    function callModalUpdateContact(index) {
        setIndex(index)
        setModalUpdateContacts(true)
    }

    function callModalAddContact(index) {
        setIndex(index)

        setModalAddContact(true)
    }

    function getContacts() {
        let teste = [];
        if (contacts) {
            for (let i = 0; i < contacts.length; i++) {
                teste[i] = [];
                teste[i].push(contacts[i].type)
                teste[i].push(contacts[i].name);
                teste[i].push(contacts[i].number);
                teste[i].push(contacts[i].email);
                teste[i].push(
                    <div className={classes2.tableActions}>
                        <Tooltip
                            id="tooltip-top"
                            title="Editar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Edit"
                                className={classes2.tableActionButton}
                                onClick={() => callModalUpdateContact(contacts)}

                            >
                                <Edit
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.edit
                                    }
                                />
                            </IconButton>

                        </Tooltip>
                        : <div />
                        {buttonDelete ? <Tooltip
                            id="tooltip-top-start"
                            title="Deletar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Close"
                                className={classes2.tableActionButton}
                                onClick={() => callModalDeleteContact(contacts[i].id)}
                            >
                                <Close
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.close
                                    }
                                />
                            </IconButton>
                        </Tooltip> : <></>}

                    </div>
                )

            }
            return teste;
        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Contatos de {props.props.social_reason}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TableContacts
                    tableHeaderColor="primary"
                    tableHead={["Tipo", "Nome", "Numero", "email", "Ações"]}
                    tableData={getContacts()}
                />
                <Form.Group as={Col} controlId="formGridName" className="d-flex justify-content-center">
                    {buttonClient ? <Tooltip
                        id="tooltip-top"
                        title="Adicionar contato"
                        placement="right"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes.buttonIcon}
                            onClick={() => callModalAddContact(contacts[0] ? contacts[0].id_client : id_client)}

                        >
                            <AddCircleOutlineIcon
                                sx={{ fontSize: 40 }}
                                className={
                                    classes.sizeAddContact + " " + classes.addContacts
                                }
                            />
                        </IconButton>
                    </Tooltip>
                        : <></>}
                </Form.Group>
            </Modal.Body>
            <ModalAddContacts key={String("AddCont_" + index.id)} props={index} show={modalAddContact} onHide={() => setModalAddContact(false)} handleShowContact={() => { }} loadContacts={() => loadContacts()} />
            <ModalDeleteContacts key={String("DeleteCont_" + index.id)} props={index} show={modalDeleteContacts} onHide={() => setModalDeleteContact(false)} handleShowContact={() => { }} loadContacts={() => loadContacts()} />
            <ModalUpdateContacts key={String("UpdCont_" + index.id)} props={index} show={modalUpdateContacts} onHide={() => setModalUpdateContacts(false)} handleShowContacts={() => { }} loadContacts={() => loadContacts()} />
        </Modal>
    );
}

export default ModalTableContacts;